<template>
  <bo-content>
    <p>巴旦木其实就是过去我们比较熟悉的大杏仁（美国加州大杏仁），只是因为其实它是扁桃仁，不是杏的仁，因此按照食品安全法，为了不让大家引起歧义，必须改为巴旦木或者扁桃仁。

从营养角度来说，它大概含有一半脂肪，还有接近20%的蛋白质，这些和一般的坚果没有太多区别，主要的差异在于它的膳食纤维、钙含量比普通坚果多很多。

</p>
  </bo-content>
</template>

<script>
import boContent from './content'

export default {
  name: 'contentdemo',
  components: {
    boContent
  },
  created() {

  },
  methods: {

  },
  data() {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// demo.vue?7ed9051b